<template>
  <v-dialog :value="reloadRequired"
            persistent
            max-width="500px">
    <v-card flat
            tile>
      <v-toolbar color="primary"
                 dark
                 flat
                 tile>
        <v-toolbar-title>
          Your Session Expired
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="py-3 px-4">
        <div>
          Your session timed out. Press the reload button.
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary"
               block
               @click.prevent="reload">
          Reload
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'reloadRequired',
    ])
  },
  methods: {
    async reload() { // MLD-4934, MLD-6145
      if (this.$root.isAdminRoute) {
        window.location.assign(`/v2/admin/email-templates`);
      } else if (this.$root.isMobileRoute) {
        window.location.assign(`/v2/mobile`);
      } else {
        window.location.assign(`/v2/app/content`);
      }
    },
  }
}
</script>
